require('jquery-modal')
$(function () {
    $("[data-modal]").on("click", function (event) {
        event.preventDefault();

        let modalElement = $(this).data("modal");

        $(modalElement).modal({
            fadeDuration: 100,
            showClose:    false,
        });

        return false;
    });

    $("[data-close-modal]").on("click", function (event) {
        event.preventDefault();

        $.modal.close();
    });
});

